var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 2,
    viewBox: "0 0 8 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5H0V1.5H8V0.5Z",
    fill: "#34373F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractIcon);
export default __webpack_public_path__ + "static/media/subtractIcon.c980d4060ab107b28ef5e7c788e65de0.svg";
export { ForwardRef as ReactComponent };